import { toast as _toast } from 'sonner'

export const toast = {
  error: (message: string) =>
    _toast.error(message, {
      dismissible: true,
      duration: 1000,
      position: 'top-center',
      style: {
        top: 60,
        background: '#ff4444',
        color: 'white',
      },
    }),
  success: (message: string, duration = 2000) =>
    _toast.error(message, {
      dismissible: true,
      duration,
      position: 'top-center',
      style: {
        top: 60,
        background: '#16c106',
        color: 'white',
      },
    }),
}
